
var btn = $('#but');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

    // Get the element by its ID
  //   var linkElement = document.querySelectorAll(".vnd a")
  // linkElement.forEach((e)=>{
  //   e.innerHTML = "View " + e.innerHTML + " Collections";
  // })